import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import sanitize from 'sanitize-html';
import { getEntityUrl } from '@culture/utils/helpers/entities';

import Thumbnail from 'components/Thumbnail';
import Icon from 'components/Icon';

import { FilePropType } from 'propTypes/common';

import styles from './styles.module.scss';

const AboutAuthor = ({ entity, mainTitle }) => {
	const { thumbnailFile, jsonBiography } = entity;
	const url = getEntityUrl('persons', entity);
	const description = parse(sanitize(jsonBiography[0]?.text));

	return (
		<div className={styles.AboutAuthor}>
			<h1 className={styles.AboutAuthor__MainTitle}>{mainTitle}</h1>
			<div className={styles.AboutAuthor__Content}>
				<Thumbnail
					file={thumbnailFile}
					params={{ width: 150, height: 150 }}
					className={styles.AboutAuthor__Image}
				/>
				<div className={styles.AboutAuthor__Info}>
					<div className={styles.AboutAuthor__Description}>{description}</div>
					<a href={url} className={styles.AboutAuthor__Link}>
						Подробнее
						<Icon
							icon="chevronRightRounded"
							className={styles.AboutAuthor__Icon}
						/>
					</a>
				</div>
			</div>
		</div>
	);
};

AboutAuthor.propTypes = {
	entity: PropTypes.shape({
		title: PropTypes.string.isRequired,
		thumbnailFile: FilePropType,
		jsonBiography: PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string
			})
		)
	}),
	mainTitle: PropTypes.string
};

export default AboutAuthor;
